import React from 'react';
import {
  useLocalization,
  useLocalizationContext,
} from '@im/react-localization';
import { IngramLogo } from '@im/ui-lib/icons/IngramLogo';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSiteConfig } from 'mf_core/config';
import { useSocialMedias } from '../IngramFooter/useSocialMedias';

export const IngramMobile = () => {
  const { siteCode } = useSiteConfig();

  const whitelistedCountries = [
    'us',
    'ca',
    'gb',
    'in',
    'mx',
    'de',
    'it',
    'es',
    'fr',
  ];

  const isNewHeader = whitelistedCountries.includes(siteCode);
  const anroidLink =
    'https://play.google.com/store/apps/details?id=com.ingrammicro.cep';

  const { translate } = useLocalization();

  const { locale } = useLocalizationContext();
  const socialMedias = useSocialMedias(locale);

  return (
    <>
      <Box padding={{ sm: 4, xs: '10px 15px' }}>
        <IngramLogo width="242" />
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: '#f8f8f8',
          justifyContent: 'center',
          padding: '10px 20px',
          verticalAlign: 'middle',
        }}
      >
        {isNewHeader ? (
          <Stack
            sx={{
              display: 'flex',
              gap: '16px',
              padding: '20px',
              textAlign: 'center',
            }}
          >
            <a href={anroidLink}>
              <img alt="Ingram Logo" src="/cep/assets/img/ingram-x-logo.png" />
            </a>
            <Typography
              sx={{ fontFamily: 'inter', fontSize: '18px', fontWeight: 600 }}
            >
              {translate('MobileWeb.LoginPageDescriptionLine1Text')}
            </Typography>
            <Typography
              sx={{ fontFamily: 'inter', fontSize: '12px', fontWeight: 400 }}
            >
              <Typography
                sx={{
                  display: 'inline',
                  fontFamily: 'inter',
                  fontSize: '12px',
                }}
              >
                {translate('MobileWeb.LoginPageDescriptionLine2Text')}{' '}
              </Typography>
              <Typography
                sx={{
                  display: 'inline',
                  fontFamily: 'inter',
                  fontSize: '12px',
                  fontWeight: 600,
                }}
              >
                {translate('MobileWeb.LoginPageDescriptionLine2BoldText')}{' '}
              </Typography>
              <Typography
                sx={{
                  display: 'inline',
                  fontFamily: 'inter',
                  fontSize: '12px',
                }}
              >
                {translate('MobileWeb.LoginPageDescriptionLine3Text')}
              </Typography>
            </Typography>
            <Stack
              direction="row"
              spacing={1}
              sx={{ justifyContent: 'center', mt: '10px' }}
            >
              {socialMedias?.appStore?.map((item) => (
                <a
                  data-name={`${item.name}-X4CMWeb`}
                  href={item.url}
                  key={item.name}
                >
                  <img
                    alt={item.name}
                    src={item.iconImage}
                    style={{ height: '40px' }}
                  />
                </a>
              ))}
            </Stack>
          </Stack>
        ) : (
          <>
            <Typography
              align="center"
              color={(theme) => theme.palette.text.secondary}
              sx={{ fontSize: '24px', fontWeight: 400 }}
            >
              Please visit on a larger device
            </Typography>
            <Typography
              align="center"
              color={(theme) => theme.palette.text.secondary}
              sx={{ fontSize: '14px', fontWeight: 400 }}
            >
              Ingram Micro Xvantage isn't currently available for mobile devices
            </Typography>
          </>
        )}
      </Box>
      <Stack
        direction={{ sm: 'row', xs: 'column' }}
        justifyContent={{ sm: 'space-between', xs: 'start' }}
        sx={{
          backgroundImage: `url('/cep/assets/img/login/login-header.png')`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: 325,
        }}
      ></Stack>
      <Box>
        <Typography
          align="center"
          color={(theme) => theme.palette.text.secondary}
          padding={1}
          variant="body2"
        >
          {translate('OktaWidget.Copyright', {
            year: new Date().getFullYear().toString(),
          })}
        </Typography>
      </Box>
    </>
  );
};
